import { IsNotEmpty, IsIn, IsOptional } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IProperty } from "../common";

export class JuniorNumberDto implements IProperty {
  //
  @IsOptional()
  type?: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.sanctioning_club))
  name: string;

  @IsNotEmpty()
  value: any;
}
